// extracted by mini-css-extract-plugin
module.exports = {"root":"TrustPilot_root__G8TcJ","link":"TrustPilot_link__a9yDc","image":"TrustPilot_image__XBfLW"};